import { ForkalkylsmallHandelssortimentDTO } from "./ForkalkylsmallHandelssortimentDTO";

export class ForkalkylsmallDTO   {

    id: number;
    namn: string;
    handelssortiment: ForkalkylsmallHandelssortimentDTO[];

    constructor() {
        this.id = undefined;
        this.namn = undefined;
        this.handelssortiment = undefined;
    }
}
